// users proportion :
// [0, 0.4[ => 0
// [0.4, 0.8[ => 1
// [0.8, 1] => 2
export const AlertsThresholds = [0.4, 0.8];

const getScore = (users: number, totalUsers: number): number => {
  if (totalUsers) {
    const ratio = users / totalUsers;
    for (let i = 0; i < AlertsThresholds.length; i++) {
      if (ratio < AlertsThresholds[i]) {
        return i;
      }
    }
  }
  return AlertsThresholds.length;
}

export const getNonAlertsScore = (alertUsers: number, totalUsers: number) => {
  const nonAlertUsers = totalUsers - alertUsers;
  return getScore(nonAlertUsers, totalUsers);
}
